import { useMemo } from 'react';
import { InsurerSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): InsurerSortingField => {
    switch (field) {
        case 'displayName':
            return InsurerSortingField.DisplayName;

        case 'module.company.displayName':
            return InsurerSortingField.CompanyDisplayName;

        case 'order':
            return InsurerSortingField.Order;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const displayNameSort = useMemo(
        () => (sort.field === InsurerSortingField.DisplayName ? sort.orderValue : undefined),
        [sort]
    );

    const companySort = useMemo(
        () => (sort.field === InsurerSortingField.CompanyDisplayName ? sort.orderValue : undefined),
        [sort]
    );

    const orderSort = useMemo(() => (sort.field === InsurerSortingField.Order ? sort.orderValue : undefined), [sort]);

    return {
        companySort,
        displayNameSort,
        orderSort,
    };
};

export default useSortOrder;
